<template>
  <div class="experiences-wrapper">
    <div class="merch-container" :style="{ 'background-color': backgroundColor1 }">
      <div v-if="slicePrimary.table_shadow1" class="table-shadow-mobile"></div>
      <div class="merch-content">
        <h2 class="title title-merch" :style="{ color: textsColor1 }">{{ slicePrimary.title1 }}</h2>
        <prismic-rich-text
          class="subtitle-exp subtitle-merch"
          :style="{ color: textsColor1 }"
          :field="slicePrimary.description1"
        ></prismic-rich-text>
        <div class="cta-wrapper w-100 d-flex justify-content-center align-items-center">
          <Button
            :extra-data="{ event: '' }"
            :blank="slicePrimary.button_blank1"
            :to="slicePrimary.button_link1[0].text"
            :font-color="buttonTextColor1"
            :with-gradient="!!buttonBackgroundColor1"
            :gradient="buttonBackgroundColor1"
            @click="
              gaEvent(getMerch, slicePrimary.button_link1[0].text, slicePrimary.button_blank1)
            "
          >
            {{ slicePrimary.button_text1[0].text }}
          </Button>
        </div>
      </div>
      <div
        class="merch-background-image"
        :style="{ 'background-image': `url(${imageUrl1})` }"
      ></div>
      <div class="merch-skewed-background" :style="{ 'background-color': backgroundColor1 }">
        <div v-if="slicePrimary.table_shadow1" class="table-shadow"></div>
      </div>
    </div>

    <div class="design-container" :style="{ 'background-color': backgroundColor2 }">
      <div v-if="slicePrimary.table_shadow2" class="table-shadow-mobile"></div>
      <div
        class="design-background-image"
        :style="{ 'background-image': `url(${imageUrl2})` }"
      ></div>
      <div class="design-skewed-background" :style="{ 'background-color': backgroundColor2 }">
        <div v-if="slicePrimary.table_shadow2" class="table-shadow"></div>
      </div>
      <div class="design-content">
        <h2 class="title" :style="{ color: textsColor2 }">{{ slicePrimary.title2 }}</h2>
        <prismic-rich-text
          class="subtitle-exp"
          :style="{ color: textsColor2 }"
          :field="slicePrimary.description2"
        ></prismic-rich-text>
        <div class="cta-wrapper button-experience">
          <Button
            :extra-data="{ event: '' }"
            :blank="slicePrimary.button_blank2"
            :to="slicePrimary.button_link2[0].text"
            :font-color="buttonTextColor2"
            :with-gradient="!!buttonBackgroundColor2"
            :gradient="buttonBackgroundColor2"
            @click="
              gaEvent(getDesign, slicePrimary.button_link2[0].text, slicePrimary.button_blank2)
            "
          >
            {{ slicePrimary.button_text2[0].text }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from 'UI/Button';
import { mapGetters } from 'vuex';

export default {
  components: {
    Button
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      textsColor1: false,
      textsColor2: false,
      buttonTextColor1: '',
      buttonTextColor2: '',
      buttonBackgroundColor1: '',
      buttonBackgroundColor2: '',
      imageAlt1: '',
      imageUrl1: '',
      imageAlt2: '',
      imageUrl2: ''
    };
  },
  computed: {
    ...mapGetters('experience', ['getMerch', 'getDesign']),
    slicePrimary() {
      return this.slice.primary;
    }
  },
  created() {
    const { primary } = this.slice;

    this.backgroundColor1 = primary.background_color1 ? primary.background_color1 : '#fff';
    this.backgroundColor2 = primary.background_color2 ? primary.background_color2 : '#fff';
    this.textsColor1 = primary.text_color1 ? primary.text_color1 : '#000';
    this.textsColor2 = primary.text_color2 ? primary.text_color2 : '#000';
    this.buttonTextColor1 = primary.button_text_color1 ? primary.button_text_color1 : '#000';
    this.buttonTextColor2 = primary.button_text_color2 ? primary.button_text_color2 : '#000';
    this.buttonBackgroundColor1 = primary.button_background_color1
      ? primary.button_background_color1
      : '#000';
    this.buttonBackgroundColor2 = primary.button_background_color2
      ? primary.button_background_color2
      : '#fff';
    this.imageUrl1 = primary.image1.url;
    this.imageUrl2 = primary.image2.url;
  },
  methods: {
    gaEvent(name, url, blank) {
      this.$ga.event('Home Hibrida', `Click Button Go ${name} Home Hibrida`, url);
      if (!blank) {
        this.$router.push(url);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0px;
  box-sizing: border-box;
}
.experiences-wrapper {
  left: -15px;
  position: relative;
  width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: fit-content;
  align-items: center;
  overflow: hidden;
  min-height: 544px;
  @include xl2 {
    min-height: 380px;
  }
  @include lg {
    min-height: unset;
    flex-direction: column;
    gap: 16px;
  }
  .merch-skewed-background {
    width: 200%;
    height: 100%;
    transform: skew(-10deg);
    position: absolute;
    right: calc(-10vw - 16px);
    z-index: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column-reverse;
    @include lg {
      display: none;
    }
  }
  .merch-container {
    z-index: 2;
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: flex-end;
    width: 40vw;
    height: fit-content;
    min-height: 544px;
    background-color: $homeMerch;
    @include xl2 {
      min-height: 380px;
    }
    @include lg {
      overflow: hidden;
      min-height: unset;
      width: 100vw;
      padding: 50px 10px;
      height: unset;
      padding-right: 24px;
    }
    .merch-background-image {
      width: 100%;
      height: 100%;
      background-size: auto 100%;
      background-position: left;
      background-repeat: no-repeat;
      position: absolute;
      z-index: 20;
      @include xl4 {
        background-position-x: -6vw;
      }
      @include xl2 {
        background-position-x: -9vw;
      }
      @include xl {
        background-position-x: -16vw;
      }
      @include lg {
        background-position-x: -34vw;
      }
      @include md {
        background-position-x: -45vw;
      }
      @include lg {
        background-size: cover;
        top: 0px;
      }
    }
  }
  .design-skewed-background {
    width: 200%;
    height: 100%;
    transform: skew(-10deg);
    position: absolute;
    left: calc(-10vw - 16px);
    border-left: 8px solid white;
    z-index: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column-reverse;
    @include lg {
      display: none;
    }
  }
  .design-container {
    z-index: 2;
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: flex-start;
    width: 41vw;
    height: fit-content;
    min-height: 544px;
    background-color: $homeDesign;
    @include xl2 {
      min-height: 380px;
    }
    @include lg {
      min-height: unset;
      overflow: hidden;
      width: 100vw;
      padding: 50px 10px;
      height: unset;
      padding-left: 24px;
    }
    .design-background-image {
      width: 100%;
      height: 100%;
      background-size: auto 100%;
      background-position: right;
      background-repeat: no-repeat;
      position: absolute;
      z-index: 20;
      @include xl4 {
        background-position-x: 12vw;
      }
      @include xl {
        background-position-x: 22vw;
      }
      @include lg {
        background-position-x: 18vw;
      }
      @include md {
        background-position-x: 26vw;
      }
      @include lg {
        background-size: cover;
        top: 0px;
        background-position-x: 42vw;
      }
    }
  }
}
.merch-content {
  display: flex;
  position: absolute;
  right: -10%;
  bottom: 25%;
  transform-origin: center center;
  z-index: 100;
  flex-direction: column;
  justify-content: center;
  width: 22vw;
  @media (min-width: #{$screen-lg-min}) and (max-width: #{$screen-xl2-max}) {
    bottom: 23%;
  }
  @include xl {
    width: 26vw;
  }
  @include lg {
    position: relative;
    top: unset;
    right: unset;
    width: 50%;
  }
}
.design-content {
  display: flex;
  position: absolute;
  left: -16%;
  bottom: 25%;
  transform-origin: center;
  z-index: 100;
  flex-direction: column;
  justify-content: center;
  width: 22vw;
  @media (min-width: #{$screen-lg-min}) and (max-width: #{$screen-xl2-max}) {
    bottom: 23%;
  }
  @include xl {
    width: 26vw;
  }
  @include lg {
    position: relative;
    top: unset;
    left: unset;
    width: 50%;
  }
}
.subtitle-exp {
  font-size: 18px;
  text-align: center;
  margin: 15px 0px 0px 0px;
  min-height: 82px;
  display: flex;
  align-items: center;
  font-weight: 400;
  line-height: 1.5;
  @media (min-width: #{$screen-lg-min}) and (max-width: #{$screen-xl2-max}) {
    margin: 5px 0px;
  }
  @include lg {
    font-size: 14px;
    min-height: unset;
  }
}
.subtitle-merch {
  color: #f3f3f3;
}
.title,
.title h1,
.title h2,
.title h3,
.title h4 {
  font-size: 64px;
  text-align: center;
  margin-bottom: 10px;
  font-weight: 400;
  @include xl2 {
    font-size: 50px;
  }
  @include lg {
    font-size: 32px;
  }
}
.title-merch {
  color: #f3f3f3;
}
.table-shadow {
  height: 22%;
  width: 200%;
  box-shadow: 0px -10px 80px 0px rgba(255, 255, 255, 0.1);
  background: #00000010;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.15) 80%);
}
.cta-wrapper {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;

  @media (min-width: #{$screen-lg-min}) and (max-width: #{$screen-xl2-max}) {
    margin-top: 15px;
  }

  @include lg {
    margin-top: 8px;
  }
}
.table-shadow-mobile {
  height: 22%;
  width: 100vw;
  bottom: 0;
  left: 0;
  display: none;
  position: absolute;
  box-shadow: 0px -10px 40px 0px rgba(255, 255, 255, 0.1);
  background: #00000010;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.06) 0%, rgba(0, 0, 0, 0.1) 80%);
  @include lg {
    display: flex;
  }
}
</style>
